// src/hooks/useElectionWebSocket.js
import {useState, useEffect, useRef, useCallback} from 'react';
import {WS_URL} from '../api/election';

export const useElectionWebSocket = (token) => {
    const [isConnected, setIsConnected] = useState(false);
    const [lastMessage, setLastMessage] = useState(null);
    const ws = useRef(null);

    useEffect(() => {
        if (!token) return;
        const wsUrl = WS_URL(token);
        ws.current = new WebSocket(wsUrl);

        ws.current.onopen = () => {
            setIsConnected(true);
        };

        ws.current.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                setLastMessage(data);
            } catch (e) {
                console.error('WebSocket parse error', e);
            }
        };

        ws.current.onclose = () => {
            setIsConnected(false);
        };

        ws.current.onerror = (error) => {
            console.error('WebSocket error', error);
        };

        return () => {
            if (ws.current && ws.current.readyState === WebSocket.OPEN) {
                ws.current.close();
            }
        };
    }, [token]);

    const sendMessage = useCallback((message) => {
        if (ws.current && ws.current.readyState === WebSocket.OPEN) {
            ws.current.send(JSON.stringify(message));
        }
    }, []);

    return {isConnected, lastMessage, sendMessage};
};